import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { PageHead, Panel, Pill } from "@/components/admin/kit";
import { Loading } from "@/components/site/Primitives";

const DeadlineList = ({ items, tone }) =>
  items.length ? items.map((p) => (
    <Link key={p.id} to={`/admin/projects/${p.id}`} className="flex justify-between py-2 border-b border-[#27272A] last:border-0 text-sm hover:text-[#00E5FF]">
      <span>{p.reference} · {p.client}</span><span className={tone}>{fmtDateTime(p.deadline)}</span>
    </Link>
  )) : <p className="text-sm text-zinc-600">None</p>;

export default function Overview() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setS(r.data));
  }, []);
  if (!s) return <Loading rows={3} />;
  const open = ["New", "Reviewing", "Awaiting Information", "Quote Sent", "Awaiting Payment", "Approved"];
  return (
    <div data-testid="admin-overview">
      <PageHead eyebrow="Overview" title="The bay today" />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-[#27272A] border border-[#27272A] mb-8">
        {open.map((k) => (
          <Link key={k} to={`/admin/enquiries?status=${encodeURIComponent(k)}`} className="bg-[#050505] p-5 hover:bg-[#121212]" data-testid={`stat-${k.toLowerCase().replace(/\s+/g, "-")}`}>
            <p className="eb-label !text-[10px]">{k}</p><p className="mt-2 font-display text-4xl font-black">{s.enquiries_by_status[k]}</p>
          </Link>
        ))}
        <Link to="/admin/projects" className="bg-[#050505] p-5 hover:bg-[#121212]" data-testid="stat-active-projects">
          <p className="eb-label !text-[10px] !text-[#00E5FF]">Active projects</p><p className="mt-2 font-display text-4xl font-black">{s.active_projects}</p>
        </Link>
      </div>
      {s.failed_notifications > 0 && (
        <Link to="/admin/emails" className="block mb-8 border border-red-500/40 bg-red-500/5 p-4 text-sm text-red-300" data-testid="failed-emails-alert">
          {s.failed_notifications} email notification(s) failed to send. Review and retry.
        </Link>
      )}
      <div className="grid lg:grid-cols-3 gap-6">
        <Panel title="Recent enquiries" className="lg:col-span-2">
          {s.recent_enquiries.length ? s.recent_enquiries.map((e) => (
            <Link key={e.id} to={`/admin/enquiries/${e.id}`} className="flex items-center justify-between gap-3 py-3 border-b border-[#27272A] last:border-0 hover:text-[#00E5FF]">
              <div className="min-w-0"><p className="text-sm truncate">{e.reference} · {e.name}{e.company && ` · ${e.company}`}</p><p className="text-xs text-zinc-600">{e.service_name} · {fmtDateTime(e.created_at)}</p></div>
              <Pill status={e.status} />
            </Link>
          )) : <p className="text-sm text-zinc-600">No enquiries yet. They'll appear here as soon as someone submits the website form.</p>}
        </Panel>
        <div className="space-y-6">
          <Panel title="Overdue first drafts"><DeadlineList items={s.overdue} tone="text-red-400" /></Panel>
          <Panel title="Due in 24 hours"><DeadlineList items={s.due_soon} tone="text-amber-300" /></Panel>
        </div>
      </div>
    </div>
  );
}
